import { Link } from 'react-router-dom';
import { useEditorAccess } from '../infra/auth/AuthContext';
import PencilIcon from './icons/PencilIcon';
import './style/EditLink.scss';

export default function EditLink({ to, label }) {
  const { canEdit } = useEditorAccess();
  return <Link className="edit-link" to={canEdit ? to : `/login?next=${encodeURIComponent(to)}`} aria-label={label}>
    <PencilIcon /><span>Edit</span>
  </Link>;
}
